<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-dialog-container change-email-container paybee-modal-content">
    <div class="modal-header modal-header-mdb ">
      <div class="step-title">Change Email</div>
    </div>
    <div class="modal-body" [formGroup]="form">
      <div class="row field-container">
        <div class="col-12">
          <mdb-form-control class="form-fill">
            <app-mdbp-input #name mdbInput formControlName="email" type="email" [showMaxLength]="false" label='Email'></app-mdbp-input>
          </mdb-form-control>
          
          <div class="mat-form-field-description mb-3 pr-5">
            <div class="mat-error">{{ getEMailError() }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer paybee-modal-footer paybee-modal-footer-mdb">
      <div class="row">
        <div class="col text-right">
          <button type="button" class="btn btn-sm modal-cancel-button close-action" (click)="close(dialog, true)">Close</button>
          <button type="button" class="btn btn-sm modal-confirm-button confirm-action" (click)="confirm(dialog, true)">Change</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
